import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { mediaCSS } from 'theme'

const styles: IStyles = {
    title: {
        fontSize: 40,
        marginBottom: 16,
    },
    content: {
        flex: '1 1 0',
        height: 'auto',
        minHeight: 0,
        marginTop: 24,
        overflow: 'hidden',
    },
    devicesPageWrapper: {
        display: 'flex',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
    },
    catalogWrapper: {
        flex: '1 1 0',
        height: '100%',
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
    },
    displaysWrapper: {
        width: '100%',
        height: '100%',
        minWidth: 0,
        minHeight: 0,
    },
    catalogContent: {
        flex: '1 1 auto',
        minHeight: 0,
    },
    mobileToolbar: {
        [mediaCSS.tab]: {
            paddingBottom: '0 !important',
            overflow: 'hidden',
        },
    },
}

addStyles(styles)

export default styles
